<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div :class="{ formBox: localStepNum != 99 }">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->
      <div class="firststep" v-if="localStepNum == 99">
        <div class="activeEdit_bottom">
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                @click="handleNav(item, index)"
                :key="item.id"
                :class="{ activeTem: index == tabActive }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 定制 -->
            <div class="temImg">
              <div
                class="temImg_content"
                @click="handleOpen()"
                style="border: 1px solid #d4e2ff"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/dz.svg"
                      alt=""
                    />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: #eaf1ff"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imageUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.imageName }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="queryId"
                  ref="queryId"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_btn pointer"
                  @click="toCreated(index + 1, item.id)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="secondstep" v-if="localStepNum == 0" v-loading="loading">
        <div style="margin-bottom: 10px">
          <jd-tip>
            说明<br />
            <template v-if="venderType">
              <p v-if="jdCrm.isCrm">
                1、云短信CRM：订购到期时间{{
                  jdCrm.endTime
                }}（自营店铺需要搭配<span
                  @click="toCRM"
                  class="pointer"
                  style="color: #fe4d45"
                  >云短信CRM</span
                >使用）
              </p>
              <p v-else>
                1、自营店铺需要搭配云短信CRM使用，<span
                  style="color: #fe4d45; cursor: pointer"
                  @click="toCRM"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </template>
            <template v-else>
              <p>1、订单完成后发放奖励。</p>
            </template>
          </jd-tip>
        </div>

        <el-form
          :model="ruleForm"
          class="backgroundForm new-input-box"
          ref="ruleForm"
          label-width="135px"
        >
          <informationForm
            v-model="ruleForm"
            needNonMember
            :defaultActivityStartTime="ruleForm.startTime"
            :defaultActivityEndTime="ruleForm.endTime"
            :defaultActMember.sync="actMember"
            :plusObject.sync="ruleDto.plusObject"
            :openCardStartTime.sync="ruleDto.openCardStartTime"
            :openCardEndTime.sync="ruleDto.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            :disabled="activityData.isStart"
            @selectPeopleSure="selectPeopleSure"
            @activityTimeChange="activityTimeChange"
            :activityId="activityData.id"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          />
          <!-- <jd-title label="基本信息" type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTime"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio
              v-model="actMember"
              label="1"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="actMember"
              label="2"
              :disabled="activityData.isStart"
              >会员身份</el-radio
            >
            <el-radio
              v-model="actMember"
              label="3"
              :disabled="activityData.isStart || softType == 1"
              >指定人群
              <el-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="activityData.isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</el-button
              >
            </el-radio>

            <div v-if="actMember == '2'" style="display: flex">
              <span>会员等级：</span>
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="activityData.isStart"
                v-if="actMember == '2'"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  label="0"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >非会员</el-checkbox
                >
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display: flex">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="activityData.isStart"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart"
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>

          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="activityData.isStart"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="activityData.isStart"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
            ></el-checkbox>
          </el-form-item> -->

          <jd-title label="活动设置" type="bold"></jd-title>
          <el-form-item label="锁权时间:" required>
            <div>
              <span class="label-right">用户在</span>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.lockStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="true"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                     <!-- @change="lockEndTimeChange" -->
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.lockEndTime"
                  default-time="23:59:59"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :picker-options="lockPickerOptions"
                  :disabled="activityData.isStart"
                  @change="lockEndTimeChange"
          
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart"
                  @click="cleaerLockTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="label-left">期间内进行锁权报名</span>
            </div>
          </el-form-item>
          <el-form-item label="兑奖时间:" required>
            <div>
              <span class="label-right">用户在</span>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.prizeStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :picker-options="prizeStartPickerOptions"
                  :disabled="activityData.isStart"
                  @change="prizeStartTimeChange"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.prizeEndTime"
                  default-time="23:59:59"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :disabled="true"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart"
                  @click="cleaerPrizeTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="label-left">期间内进行奖品领取</span>
            </div>
          </el-form-item>
          <el-form-item label="兑奖方式:" required>
            <el-radio v-model="getPrizeType" :label="1"
              >用户手动领取（用户需要在兑奖时间内，在活动详情页手动领取商品）</el-radio
            >
          </el-form-item>

          <el-form-item label="锁权规则:" required>
            <el-radio
              v-model="ruleForm.lockType"
              :disabled="activityData.isStart"
              :label="0"
              >积分锁权</el-radio
            >
            <el-radio
              v-model="ruleForm.lockType"
              :disabled="activityData.isStart"
              :label="1"
              >N元锁权</el-radio
            >
            <el-form-item
              label="锁权所需积分:"
              required
              label-width="120px"
              v-if="ruleForm.lockType == 0"
            >
              <el-input
                v-model="ruleForm.point"
                @input="ruleForm.point = getNumberData(1, $event, 0, 1, 999999)"
                style="width: 140px"
                placeholder="请输入"
                :disabled="activityData.isStart"
              ></el-input
              ><span class="label-left">积分</span>
            </el-form-item>
            <div v-else>
              <el-form-item label="锁权要求:" label-width="120px">
                <div v-if="!venderType">
                  用户领取特惠商品权益后并进行下单后可以完成锁权
                </div>
                <div v-else>用户领取令牌后并进行下单指定商品可以完成锁权</div>
              </el-form-item>
              <div v-if="!venderType">
                <el-form-item
                  label="选择特惠商品:"
                  label-width="120px"
                  required
                >
                  <jd-button type="blue" :disabled="activityData.isStart" @click="selectExclusivePrice"
                    >选择专享价活动</jd-button
                  >
                </el-form-item>
              </div>

              <el-form-item label="添加令牌：" required v-else>
                <template slot-scope="scope">
                  <jd-button type="blue" @click="isShowselectToken = true"
                    >选择令牌</jd-button
                  >
                </template>
              </el-form-item>
              <!-- POP店铺 -->
              <div v-if="!venderType && ruleForm.assetsId">
                <el-form-item label="活动时间:" label-width="120px">
                  <div>
                    {{ exclusivePriceData.startTime }} ~
                    {{ exclusivePriceData.endTime }}
                  </div>
                </el-form-item>
                <el-form-item label="商品限购:" label-width="120px">
                  <div class="flexc-cen-x">
                    <div class="mr8">每笔订单中每个商品最少购买</div>
                    <el-input
                      v-model="exclusivePriceData.minItemNum"
                      style="width: 90px"
                      placeholder="请输入"
                      :disabled="true"
                    ></el-input>
                    <div class="ml8 mr8">件，最多购买</div>
                    <el-input
                      v-model="exclusivePriceData.maxItemNum"
                      style="width: 90px"
                      placeholder="请输入"
                      :disabled="true"
                    ></el-input>
                    <div class="ml8">才能展示并享受专享价</div>
                  </div>
                </el-form-item>
                <el-form-item label="特惠商品:" label-width="120px">
                  <jd-table
                    :tableInfo="tableInfo"
                    :tableData="currentExclusivePriceData"
                    :pageInfo="{
                      pageNum: pageInfo.current,
                      pageSize: pageInfo.size,
                      total: exclusivePriceData.skuList.length,
                    }"
                    :maxHeight="300"
                    @handlePage="handlePage"
                    v-if="currentExclusivePriceData.length > 0"
                  >
                    <template #skuNameSlot="{ row }">
                      <div class="flexc-cen-x">
                        <img
                          :src="row.logo"
                          style="width: 60px; height: 60px"
                        />
                        <div style="margin-left: 8px">
                          <div>商品名称：{{ row.skuName }}</div>
                          <div>SKUID：{{ row.skuId }}</div>
                        </div>
                      </div>
                    </template>
                    <template #discountSlot="{ row, rowIndex }">
                      <div class="flexc-cen-x">
                        <div>{{ row.discount }}</div>
                        <div>折</div>
                      </div>
                    </template>
                    <template #discountAmountSlot="{ row, rowIndex }">
                      <div class="flexc-cen-x">
                        <div>{{ row.discountAmount }}</div>
                        <div>元</div>
                      </div>
                    </template>
                    <template #payPriceSlot="{ row }">
                      <div class="flexc-cen-x">
                        <div>{{ row.payPrice }}</div>
                        <div>元</div>
                      </div>
                    </template>
                  </jd-table>
                </el-form-item>
              </div>
              <!-- 自营店铺 -->
              <div v-if="venderType && ruleForm.assetsId">
                <el-form-item label=" ">
                  <jd-table
                    :tableInfo="tokenInfo"
                    :tableData="tokenData"
                    :pageInfo="{ noShow: true }"
                    :maxHeight="300"
                    @handlePage="handlePage"
                    v-if="tokenData.length > 0"
                  >
                    <template #statusTimeSlot="{ row }">
                      <div class="flexc-cen-x">
                        {{ row.startTime }} ~ {{ row.endTime }}
                      </div>
                    </template>
                    <template #actionSlot="{ row, rowIndex }">
                      <jd-button
                        type="blueText"
                        size="small"
                        @click="removeToken(rowIndex)"
                        >移除</jd-button
                      >
                    </template>
                  </jd-table>
                </el-form-item>
                <el-form-item
                  label="令牌中绑定的促销活动:"
                  required
                  label-width="170px"
                  v-if="focus.length > 0"
                >
                  <div v-for="(item, index) in focus" :key="index">
                    <div
                      style="
                        background-color: rgb(250, 250, 250, 0.5);
                        width: 800px;
                        padding: 15px;
                        margin-top: 10px;
                      "
                    >
                      <el-form-item label="促销活动时间:" required>
                        <div>
                          {{ item.timesOne }}- {{ item.timesTwo }}
                        </div>
                      </el-form-item>
                      <el-form-item label="促销商品:" required v-if="item.promotiProducts.length > 0">
                        <!-- 商品列表表格 -->
                        <frontPageTable
                          :productList="item.promotiProducts"
                          :headerCellStyle="{
                            'text-align': 'center',
                            'border-bottom': '2px solid #EBEEF5',
                            background: '#FAFAFA',
                          }"
                          :cellStyle="{
                            'text-align': 'center',
                            overflow: 'visible',
                          }"
                          :tableStyle="'width: 700px; overflow: visible;'"
                          :paginationStyle="'width: 700px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'"
                        >
                          <template #tableContent>
                            <el-table-column label="商品名称" prop="skuName">
                            </el-table-column>
                            <el-table-column label="skuid" prop="skuId">
                            </el-table-column>
                            <el-table-column label="京东价" prop="jdPrice">
                            </el-table-column>
                          </template>
                        </frontPageTable>
                      </el-form-item>
                      <el-form-item label="赠品SKU:" required v-if="item.promotiProductsOne.length > 0">
                        <frontPageTable
                          :productList="item.promotiProductsOne"
                          :headerCellStyle="{
                            'text-align': 'center',
                            'border-bottom': '2px solid #EBEEF5',
                            background: '#FAFAFA',
                          }"
                          :cellStyle="{
                            'text-align': 'center',
                            overflow: 'visible',
                          }"
                          :tableStyle="'width: 700px; overflow: visible;'"
                          :paginationStyle="'width: 700px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'"
                        >
                          <template #tableContent>
                            <el-table-column label="商品名称" prop="skuName">
                            </el-table-column>
                            <el-table-column label="主SKU">
                              <template slot-scope="scope">
                                <span>{{ scope.row.skuId }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column>
                              <template slot="header" slot-scope="scope">
                                <span>影分身SKU</span>
                                <el-tooltip
                                  class="item"
                                  effect="light"
                                  content="影分身SKU用于核销校验主SKU号+影分身标题"
                                  placement="bottom"
                                >
                                  <span class="question-style">
                                    <i class="el-icon-question"></i>
                                  </span>
                                </el-tooltip>
                              </template>
                              <template slot-scope="scope">
                                <span>{{ scope.row.shadowSkuId }}</span>
                              </template>
                            </el-table-column>
                          </template>
                        </frontPageTable>
                      </el-form-item>
                    </div>
                  </div>
                </el-form-item>
              </div>
              <el-form-item label="订单状态:" label-width="120px" required>
                <el-radio-group v-model="ruleForm.lockOrderStateType">
                  <el-radio :label="0">已完成</el-radio>
                  <el-radio :label="1"
                    >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>
          </el-form-item>

          <el-form-item label="订单要求:" required>
            <div class="rule_box">
              <div class="rule_box_top">
                用户所下订单满足以下条件可以领取奖品
              </div>
              <div class="rule_box_middle">
                <el-form-item label="下单店铺:" required>
                  <orderShopCom
                    :venderIds.sync="ruleDto.venderIds"
                    :multiShopGoods.sync="multiShopGoods"
                    :sellerSkuList.sync="ruleDto.sellerSkuList"
                    :isDisabled="activityData.isStart"
                  />
                </el-form-item>
                <el-form-item label="下单时间:" required>
                  <span class="label-right">用户在</span>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderStartTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :picker-options="orderStartPickerOptions"
                      :disabled="activityData.isStart"
                      @change="orderStartTimeChange"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderEndTime"
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :picker-options="orderEndPickerOptions"
                      :disabled="activityData.isStart"
                      @change="orderEndTimeChange"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="clearOrderTime"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <span class="label-left">期间内下单</span>
                </el-form-item>
                <el-form-item label="金额统计类型:" required>
                  <el-radio-group
                    v-model="ruleForm.orderPaymentType"
                    :disabled="activityData.isStart "
                    @change="ruleForm.filterSkuType = 0"
                  >
                    <el-radio :label="1">
                      <span>订单金额（后台价）</span>
                      <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="0" v-if="!isVenderType">
                      <span>用户应付金额</span>
                      <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="2" v-if="!isVenderType">
                      <span>用户实付金额</span>
                      <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                  </el-radio-group>
                  <div style="color: red">
                    注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                  </div>
                </el-form-item>
                <el-form-item label="商品要求:" required>
                  <!-- <el-radio-group
                    v-model="ruleForm.filterType"
                    :disabled="activityData.isStart"
                    @change="filterTypeChange"
                  >
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">指定商品</el-radio>
                    <el-radio :label="2">排除商品</el-radio>
                  </el-radio-group>
                  <jd-button
                    type="default"
                    :class="[{ 'global-view-btn': backgroundOpacity }]"
                    :style="{
                      margin: ' 0 0px 0 15px',
                    }"
                    @click="exposureProducts"
                    :disabled="ruleForm.filterType == 0"
                  >
                    {{
                      selectGoodsArr.length != ""
                        ? "已选" + selectGoodsArr.length + "个"
                        : "+添加"
                    }}
                  </jd-button> -->
                  <productReqCom
                    :filterType.sync="ruleForm.filterType"
                    :venderIds.sync="ruleDto.venderIds"
                    :sellerSkuList.sync="ruleDto.sellerSkuList"
                    :multiShopGoods.sync="multiShopGoods"
                    :isCreated="isCreated"
                    :isDisabled="activityData.isStart"
                    addGoodText="已选"
                    @changeFilterType="ruleForm.filterSkuType = 0"
                  />
                </el-form-item>
                <el-form-item label="排除商品规则:" v-if="ruleForm.orderPaymentType==1&&ruleForm.filterType == 2">
                  <el-select style="width: 280px;" v-model="ruleForm.filterSkuType" :disabled="activityData.isStart || ruleForm.orderPaymentType == 0" placeholder="">
                    <el-option label="只要订单包含指定商品就整单排除" :value="0"></el-option>
                    <el-option label="仅排除指定商品的商品件数及金额（仅订单金额）" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="指定商品规则:" v-if="ruleForm.orderPaymentType==1&&ruleForm.filterType == 1">
                  <el-select style="width: 280px;" v-model="ruleForm.filterSkuType" :disabled="activityData.isStart" placeholder="">
                    <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                    <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                  </el-select>
                  <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                </el-form-item>
                <el-form-item label="商品件数:">
                  <el-input
                    v-model="ruleForm.itemStartCount"
                    @input="
                      ruleForm.itemStartCount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input>
                  <span class="label-left">件及以上</span>
                </el-form-item>
                <el-form-item label="订单金额:" required>
                  <el-input
                    v-model="ruleForm.orderStartPayment"
                    @input="ruleForm.orderStartPayment =
                        getNumberData(1, $event, 1, 0)
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  ><span class="label-left">元及以上</span>
                </el-form-item>
                <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.mergeOrder"
                  >
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                  <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                </el-form-item>
                <el-form-item label="订单状态:" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.orderStateType"
                  >
                    <el-radio :label="0">已完成</el-radio>
                    <el-radio :label="1"
                      >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="下单跳转链接:" required>
                  <el-radio-group
                    v-model="ruleForm.goShopSetting"
                    :disabled="activityData.isStart"
                    @change="onShopSetChange"
                  >
                    <el-radio :label="0">进入店铺首页</el-radio>
                    <el-radio :label="1">跳转指定小程序</el-radio>
                    <el-radio :label="2">进入指定链接</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-if="ruleForm.goShopSetting == 1">
                  <el-form-item label="小程序appId:" required>
                    <el-input
                      type="textarea"
                      placeholder="请输入小程序appId"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="ruleForm.goShopAppId"
                      :disabled="activityData.isStart"
                      :maxlength="1000"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="页面路径path:">
                    <el-input
                      type="textarea"
                      placeholder="请输入小程序页面路径path"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="ruleForm.goShopUrl"
                      :disabled="activityData.isStart"
                      :maxlength="1000"
                    ></el-input>
                    <div style="color: #f56c6c">
                      注意：path若不写，则默认进入小程序主页。
                    </div>
                  </el-form-item>
                </div>
                <el-form-item
                  label="指定链接:"
                  required
                  v-if="ruleForm.goShopSetting == 2"
                >
                  <el-input
                    type="textarea"
                    placeholder="请输入指定链接"
                    style="width: 425px; margin-left: 8px"
                    show-word-limit
                    v-model="ruleForm.goShopUrl"
                    :disabled="activityData.isStart"
                    :maxlength="1000"
                  ></el-input>
                  <div style="color: #f56c6c">
                    注意：仅可填写京东域内的
                    H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form-item>

          <!-- 奖品发放形式 -->
          <el-form-item label="奖品发放形式:" required>
            <div style="display: flex; align-items: center">
              <el-radio
                v-model="ruleDto.sendType"
                :label="0"
                :disabled="activityData.isStart"
                >立即发放</el-radio
              >
              <el-radio
                @change="ruleDto.sendDay = ''"
                v-model="ruleDto.sendType"
                :label="1"
                :disabled="activityData.isStart"
                >确认收货
                <el-input
                  v-if="ruleDto.sendType == 1"
                  v-model="ruleDto.sendDay"
                  :disabled="activityData.isStart"
                  placeholder="请输入天数"
                  @input="(e) => (ruleDto.sendDay = validSe(e))"
                  style="width: 80px; margin: 0 4px"
                ></el-input>
                <el-input
                  :disabled="true"
                  style="width: 80px; margin: 0 4px"
                  v-else
                ></el-input>
                天后发放</el-radio
              >
              <el-radio
                @change="ruleDto.sendDay = ''"
                v-model="ruleDto.sendType"
                :label="2"
                :disabled="activityData.isStart"
                >活动结束
                <el-input
                  v-if="ruleDto.sendType == 2"
                  v-model="ruleDto.sendDay"
                  :disabled="activityData.isStart"
                  placeholder="请输入天数"
                  @input="(e) => (ruleDto.sendDay = validSe(e))"
                  style="width: 80px; margin: 0 4px"
                ></el-input>
                <el-input
                  :disabled="true"
                  style="width: 80px; margin: 0 4px"
                  v-else
                ></el-input>
                天后发放</el-radio
              >
              <el-tooltip placement="top-start" effect="dark">
                <div slot="content">
                  1.立即发放:用户下单符合条件后，系统立即发放奖品;<br />
                  2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                  3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                </div>
                <div>发放规则<i class="el-icon-question"></i></div>
              </el-tooltip>
            </div>
          </el-form-item>

          <el-form-item label="奖品规则:">
            <div class="rule_box" style="width: 1400px">
              <el-radio-group
                v-model="ruleForm.prizeSettingType"
                :disabled="activityData.isStart"
                style="margin-bottom: 20px"
                @change="changePrizeSettingType"
              >
                <el-radio :label="0">统一奖品</el-radio>
                <el-radio :label="1">阶梯奖品</el-radio>
              </el-radio-group>

              <el-form-item
                label="奖品设置:"
                required
                v-if="ruleForm.prizeSettingType == 0"
                label-width="100px"
              >
                <jd-table :tableData="prizeSettingList" style="width: 1100px">
                  <el-table-column label="奖品类型">
                    <template slot-scope="scope">
                      {{ getPrizeTypeName(scope.row.prizeType) }}
                      <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                      <span v-if="scope.row.prizeType == 2">京豆</span>
                      <span v-if="scope.row.prizeType == 3">实物</span>
                      <span v-if="scope.row.prizeType == 4">店铺积分</span>
                      <span v-if="scope.row.prizeType == 5">京东E卡</span>
                      <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                      <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                      <span v-if="scope.row.prizeType == 8">现金红包</span>
                      <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                      <span v-if="scope.row.prizeType == 10">礼品卡</span>
                      <span v-if="scope.row.prizeType == 12">{{
                        venderType ? "令牌" : "专享价"
                      }}</span>
                      <span v-if="scope.row.prizeType == 13">令牌</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品价值" width="80" prop="price">
                  </el-table-column>
                  <el-table-column label="奖品图片(646px*646px)" width="200">
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo"
                        style="width: 56px; height: 56px"
                      />
                    </template>
                  </el-table-column>

                  <el-table-column label="奖品名称" width="299">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.title"
                        maxlength="12"
                        show-word-limit
                        style="width: 240px"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="奖品数量" width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.totalAmount"
                        @input.native="
                          (e) =>
                            (scope.row.totalAmount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        placeholder="请输入"
                        @input="
                          (scope.row.totalAmount = getNumberData(
                            1,
                            $event,
                            0,
                            1,
                            999999
                          )),
                            prizeNum(scope.row)
                        "
                        @blur="beAdd(scope.row)"
                        :disabled="
                          (activityData.isStart && !scope.row.minNum) ||
                          activityData.isStart
                        "
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                      <div class="flex-center">
                        <jd-button
                          type="blueText"
                          @click="centerVis(scope.row)"
                          :disabled="activityData.isStart"
                          >选奖品</jd-button
                        >
                        <el-upload
                          class="label-left"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="beforeUpload"
                          :on-success="(res) => handleUpload(res, scope.row)"
                          :disabled="activityData.isStart"
                        >
                          <jd-button :disabled="activityData.isStart" type="blueText">上传图片</jd-button>
                        </el-upload>
                        <jd-button
                          type="blueText"
                          style="margin-left: 5px"
                          v-if="activityData.isStart && scope.row.title"
                          @click="itemAddNum('prizeSettingList', scope.$index)"
                          >增加奖品数量</jd-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </jd-table>
                <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              </el-form-item>

              <div v-if="ruleForm.prizeSettingType == 1">
                <el-form-item label-width="100px" label="统计规则：" required>
                  <el-select
                    v-model="ruleForm.orderCountType"
                    :disabled="activityData.isStart"
                  >
                    <el-option label="累计订单满" :value="0"></el-option>
                    <el-option label="单笔订单满" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="领取规则：" required label-width="100px">
                  <el-radio-group
                    v-model="ruleForm.receiveType"
                    :disabled="activityData.isStart"
                  >
                    <el-radio :label="0">仅可领取一次</el-radio>
                    <el-radio :label="1">可领取全部</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="阶梯设置：" label-width="100px" required>
                  <jd-button
                    type="blue"
                    :disabled="backgroundOpacity || activityData.isStart"
                    @click="addPrizeRule"
                  >
                    添加阶梯（{{ prizeSettingList.length }}/5）
                  </jd-button>
                  <div
                    v-for="(item, index) in prizeSettingList"
                    :key="index"
                    style="background: #fff; margin-top: 15px"
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background: #f0f2f7;
                        padding: 8px;
                      "
                    >
                      <span>阶梯{{ index + 1 }}</span>
                      <i
                        class="el-icon-delete"
                        style="font-size: 18px; cursor: pointer; color: red"
                        @click="itemDel(index)"
                      ></i>
                    </div>
                    <div style="padding: 10px">
                      <el-form-item label="消费门槛：" required>
                        <span>金额≥</span>
                        <el-input
                          v-model="item.orderPaymentLimit"
                          placeholder="请输入"
                          style="width: 100px; margin: 0 4px"
                          :disabled="activityData.isStart"
                          @input="
                            item.orderPaymentLimit = getNumberData(
                              1,
                              $event,
                              1,
                              0
                            )
                          "
                          @blur="cumulativePayAmountChange(item, index)"
                        ></el-input>
                        <span>元</span>
                      </el-form-item>
                      <el-form-item label="奖品设置：" required>
                        <div style="width: 100%">
                          <jd-table :tableData="[item]" style="width: 1100px">
                            <el-table-column label="奖品类型">
                              <template slot-scope="scope">
                                {{ getPrizeTypeName(scope.row.prizeType) }}
                                <!-- <span v-if="scope.row.prizeType == 1"
                                  >优惠券</span
                                >
                                <span v-if="scope.row.prizeType == 2"
                                  >京豆</span
                                >
                                <span v-if="scope.row.prizeType == 3"
                                  >实物</span
                                >
                                <span v-if="scope.row.prizeType == 4"
                                  >店铺积分</span
                                >
                                <span v-if="scope.row.prizeType == 5"
                                  >京东E卡</span
                                >
                                <span v-if="scope.row.prizeType == 6"
                                  >爱奇艺会员</span
                                >
                                <span v-if="scope.row.prizeType == 7"
                                  >京东PLUS会员</span
                                >
                                <span v-if="scope.row.prizeType == 8"
                                  >现金红包</span
                                >
                                <span v-if="scope.row.prizeType == 9"
                                  >谢谢参与</span
                                >
                                <span v-if="scope.row.prizeType == 10"
                                  >礼品卡</span
                                >
                                <span v-if="scope.row.prizeType == 12">{{
                                  venderType ? "令牌" : "专享价"
                                }}</span>
                                <span v-if="scope.row.prizeType == 13">令牌</span> -->
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="奖品价值"
                              width="80"
                              prop="price"
                            >
                            </el-table-column>
                            <el-table-column
                              label="奖品图片(646px*646px)"
                              width="200"
                            >
                              <template slot-scope="scope">
                                <img
                                  v-if="scope.row.logo"
                                  :src="scope.row.logo"
                                  style="width: 56px; height: 56px"
                                />
                              </template>
                            </el-table-column>

                            <el-table-column label="奖品名称" width="299">
                              <template slot-scope="scope">
                                <el-input
                                  v-model="scope.row.title"
                                  maxlength="12"
                                  show-word-limit
                                  style="width: 240px"
                                ></el-input>
                              </template>
                            </el-table-column>

                            <el-table-column label="奖品数量" width="180">
                              <template slot-scope="scope">
                                <el-input
                                  v-model.number="scope.row.totalAmount"
                                  @input.native="
                                    (e) =>
                                      (scope.row.totalAmount = checkputn(
                                        e,
                                        scope.row,
                                        'jindou'
                                      ))
                                  "
                                  placeholder="请输入"
                                  @input="
                                    (scope.row.totalAmount = getNumberData(
                                      1,
                                      $event,
                                      0,
                                      1,
                                      999999
                                    )),
                                      prizeNum(scope.row)
                                  "
                                  @blur="beAdd(scope.row)"
                                  :disabled="
                                    (activityData.isStart &&
                                      !scope.row.minNum) ||
                                    activityData.isStart
                                  "
                                ></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="每日发放限额" width="120">
                              <template slot-scope="scope">
                                <dailyLimitConfig
                                  :row="scope.row"
                                  :backgroundOpacity="backgroundOpacity"
                                  :limitBtnDisabled="backgroundOpacity"
                                ></dailyLimitConfig>
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="操作"
                              width="200"
                              fixed="right"
                            >
                              <template slot-scope="scope">
                                <div class="flex-center">
                                  <jd-button
                                    type="blueText"
                                    @click="centerVisStep(item, index)"
                                    :disabled="activityData.isStart"
                                    >选奖品</jd-button
                                  >
                                  <el-upload
                                    class="label-left"
                                    action="/jd-hd-web/image/upload"
                                    :show-file-list="false"
                                    :before-upload="beforeUpload"
                                    :on-success="
                                      (res) => handleUpload(res, item)
                                    "
                                    :disabled="activityData.isStart"
                                  >
                                    <jd-button type="blueText" :disabled="activityData.isStart"
                                      >上传图片</jd-button
                                    >
                                  </el-upload>
                                  <jd-button
                                    type="blueText"
                                    style="margin-left: 5px"
                                    v-if="activityData.isStart && item.title"
                                    @click="
                                      itemAddNum('prizeSettingList', index)
                                    "
                                    >增加奖品数量</jd-button
                                  >
                                </div>
                              </template>
                            </el-table-column>
                          </jd-table>
                          <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <activityPageSettings
            isShowShopName
            isShowShopNameByChannel
            isShowMoreSet
            v-model="customerPaperwork"
            defaultTitleKey="activityTheme"
            defaultDescKey="activityRemark"
            defaultTitleColorKey="textColor"
            :cusTemplateJSON.sync="ruleDto.cusTemplateJSON"
            :giftList="newGiftList"
            :templateId="templateId"
            :widthNumber="750"
            :heightNumber="1624"
            :defaultRgb="currrentRgb"
            :isCustomPreview="customerPaperwork.layout==3"
            @selectTemplate="selectTemplate"
            :designSpecificationsUrl="designSpecificationsUrl"
          >
            <template #customPreview>
              <newLockPreview :customerPaperwork="customerPaperwork" :backgroundImage="backgroundImage" :templateObj="templateObj" :ruleForm="ruleForm"/>
            </template>
            <template #otherSetHead>
              <el-form-item label="模板类型:" required>
                <el-radio-group v-model="customerPaperwork.layout" @change="changeLayout">
                  <el-radio :label="2">样式一</el-radio>
                  <el-radio :label="3">样式二</el-radio>
                </el-radio-group>
            </el-form-item>
            </template>
            <template #otherSet>
              <div v-if="customerPaperwork.layout==3">
                <customUpload
                :customerPaperwork="customerPaperwork"
                labelWidth="135px"
                bgKey="btnUrl"
                :pw="480"
                :ph="98"
                labelText="按钮背景图:"
                bgLabelText="按钮背景图"
                :backgroundOpacity="backgroundOpacity"
              />
              <customText
                :customerPaperwork="customerPaperwork"
                labelText="按钮文案颜色:"
                colorKey="btnColor"
                labelWidth="135px"
                :backgroundOpacity="backgroundOpacity"
                :resetColor="currrentRgb2"
              />
              <customText
                :customerPaperwork="customerPaperwork"
                labelText="流程文案颜色:"
                colorKey="processColor"
                labelWidth="135px"
                :backgroundOpacity="backgroundOpacity"
                :resetColor="currrentRgb3"
              />
              </div>
            </template>
          </activityPageSettings>
          <exposureList
            v-model="itemListForFilter"
            :defaultExposureSwitch.sync="ruleForm.exposureSwitch"
            :isLimit="true"
            :limitNum="limitNum" 
            :isEdit="isCreated" 
            :multiShopSkuType.sync="multiShopSkuType" 
            :multiShopGoods="multiShopGoods"
            :skuBelongVenderId="skuBelongVenderId"
          />
          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox" style="z-index: 1">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[
                { add_btn1: ruleForm.exposureSwitch },
                { 'global-view-btn': backgroundOpacity },
              ]"
              style="margin: 0 15px"
              @click="exposureProductsFiter"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListForFilter.length != ""
                  ? "添加曝光商品" +
                    "(" +
                    itemListForFilter.length +
                    "/20" +
                    ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListForFilter.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <template>
            <sharFrom v-model="ruleForm" :sharePic="sharePic" />
            <!-- <jd-title label="分享设置" type="bold"></jd-title>
            <el-form-item label="小程序分享标题:" required label-width="125">
              <el-input
                type="text"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.shareTitle"
                :maxlength="28"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享简介:" required label-width="125">
              <el-input
                type="text"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.shareIntroduce"
                :maxlength="28"
                @input="$forceUpdate()"
              ></el-input>
            </el-form-item>
            <el-form-item label="小程序分享图片:" required label-width="130">
              <div class="miniAppPic" style="margin-left: 16px">
                <div class="top">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUpload1"
                    :on-success="handleUpload1"
                  >
                    <jd-button type="blueText">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    type="blueText"
                    style="margin-left: 20px"
                    @click="picUrlReset1"
                    >重置</jd-button
                  >
                </div>
                <div class="bottom">
                  <el-image
                    class="elImg"
                    :src="ruleForm.sharePic"
                    fit="contain"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-image>
                  <div class="tips1">
                    <p>建议上传尺寸：200px * 200px</p>
                    <p>图片大小：1MB以内</p>
                    <p>格式：jpg、png</p>
                  </div>
                </div>
              </div>
            </el-form-item> -->
          </template>
          <activityRules
            v-model="ruleForm.ruleDescription"
            :isForceRemind.sync="ruleDto.isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          />
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                :maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                show-word-limit
              >
              </el-input>
              <div style="margin-top: 16px">
                <jd-button type="blue" @click="generateRule"
                  >生成规则</jd-button
                >
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->

          <!-- <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum != 99">
      <jd-button
        style="margin-right: 8px"
        v-show="!itemId && backgroundOpacity"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :hideShopPoints="true"
      :actType="45"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          >确 定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :hasSelectGoods="hasSelectGoods"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :isClear="activityData.isStart"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <selectSpecialDialog
      v-if="isShowExclusivePrice"
      v-model="isShowExclusivePrice"
      :exclusivePriceId="ruleForm.assetsId"
      @confirm="confirmExclusive"
    ></selectSpecialDialog>

    <selectTokenDialog
      v-if="isShowselectToken"
      v-model="isShowselectToken"
      :tokenId="ruleForm.assetsId"
      @confirm="confirmToken"
    ></selectTokenDialog>
  </div>
</template>

<script>
import informationForm from "./components/informationForm.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import draggable from "vuedraggable";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import QRCode from "qrcodejs2";
import {
  pointLockSave,
  getPointLockDetail,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { publicOpen } from "@/api/jhk/public";
import selectSpecialDialog from "./components/selectSpecialDialog.vue";
import selectTokenDialog from "@/views/interactiveMarketing/promo/components/selectTokenDialog.vue";
import frontPageTable from "./components/frontPageTable.vue";
import { getExclusivePricePlanDetail } from "@/api/jhk/integralCenter/prizeCenter.js";
//令牌详情接口
import { promoTokenDetail } from "@/api/integralCenter/tokenSummary.js";
const defaultTextColor = "#ffffff";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods, useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
import customUpload from "./components/commCustomizationSet/customUpload.vue";
import customText from "./components/commCustomizationSet/customText.vue";
import newLockPreview from "./components/newActPreviews/newLockPreview.vue";
export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    informationForm,
    activityPageSettings,
    exposureList,
    sharFrom,
    activityRules,
    selectSpecialDialog,
    selectTokenDialog,
    frontPageTable,
    dailyLimitConfig,
    orderShopCom,
    productReqCom,
    customUpload,
    customText,
    newLockPreview
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || "";
    },
    currentExclusivePriceData() {
      return this.exclusivePriceData.skuList.slice(
        (this.pageInfo.current - 1) * this.pageInfo.size,
        this.pageInfo.current * this.pageInfo.size
      );
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
    isPop() {
      return this.multiShopGoods.every((item) => !item.venderType);
    },
    designSpecificationsUrl() {
      let urls = {
        2: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/lock-right.png",
        3: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/new-lock-right.png",
      };
      return urls[this.customerPaperwork.layout];
    },
    newGiftList() {
      return this.allGiftList.filter((item) => item.layout == this.customerPaperwork.layout);
    },
    backgroundImage() {
      return this.ruleDto.cusTemplateJSON ? JSON.parse(this.ruleDto.cusTemplateJSON).activityBgImg : this.templateObj.url
    },
  },
  watch: {
    theNum() {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(3);
    },
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, "锁权有礼-常规", "互动管理", "互动活动");
      }
    },
    "ruleForm.lockType"(newVal) {
      if (newVal == 0) {
        this.ruleForm.assetsId = "";
        this.exclusivePriceData = {};
      } else {
        this.ruleForm.point = "";
      }
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if(newVal) {
    //     this.ruleForm.orderPaymentType = 0
    //   } else {
    //     this.ruleForm.orderPaymentType = 1
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.ruleForm.orderPaymentType = 1
      } 
      // else {
      //   this.ruleForm.orderPaymentType = 0
      // }
    },
    newGiftList: {
      handler(newVal, oldVal) {
        if(newVal.length>0){
          if(this.valueRow && this.valueRow.id) {
            const obj = newVal.find(item => item.id == this.templateId)
            if(obj&&this.customerPaperwork.layout==3) {
              // 兼容旧活动自定义字段没有参数
              this.defaultCustomSet(obj)
            }
    
          } else {
            if(this.customerPaperwork.layout==3){
              this.currentSet(newVal[0])
            }
          }
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      templateObj: {},
      allGiftList: [],
      moduleType: 2,
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      customerPaperwork: {
        activityTheme: "锁权有礼",
        activityRemark: "锁权后下单赢好礼",
        textColor: defaultTextColor,
        layout: 2,
        btnUrl: "",
        btnColor: "",
        processColor: "",
      },
      limitNum: 20,
      multiShopSkuType: 0,
      belongVenderId: "",
      isCreated: false,
      loading: false,
      focus: [],
      tokenData: [],
      tokenInfo: [
        {
          label: "令牌名称",
          prop: "name",
          minWidth: 150,
        },
        {
          label: "令牌ID",
          prop: "tokenId",
          minWidth: 130,
        },
        {
          label: "令牌秘钥",
          prop: "secretKey",
          minWidth: 130,
        },
        {
          label: "令牌有效时间",
          prop: "statusTime",
          slot: "statusTimeSlot", //插槽
          minWidth: 180,
        },
        {
          label: "操作",
          prop: "action",
          slot: "actionSlot", //插槽
          minWidth: 150,
        },
      ],
      tokenDetail: {},
      isShowselectToken: false,
      tableInfo: [
        {
          label: "商品信息",
          prop: "skuName",
          slot: "skuNameSlot", //插槽
          minWidth: 280,
        },
        {
          label: "京东价",
          prop: "jdPrice",
          width: "150",
          minWidth: 100,
        },
        {
          label: "折扣",
          prop: "discount",
          slot: "discountSlot", //插槽
          minWidth: 150,
        },
        {
          label: "减价",
          prop: "discountAmount",
          slot: "discountAmountSlot", //插槽
          minWidth: 120,
        },
        {
          label: "促销价",
          prop: "payPrice",
          slot: "payPriceSlot", //插槽
          minWidth: 120,
        },
      ],
      pageInfo: {
        current: 1,
        size: 10,
      },
      exclusivePriceData: {},
      isShowExclusivePrice: false,
      // 回显已经保存过的商品
      hasSelectGoods: [],
      actEndTime: "",
      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      templateId: "",
      tabActive: 0,
      navItem: "",
      giftList: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      itemArr: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      echoDate: {},
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      showSelectProduct: false,
      // 1.14迭代 指定入会时间
      ruleDto: {
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
        cusTemplateJSON: "",
        isForceRemind: false,
        sendType: 0, //奖品发放形式: 0立即发放, 1确认收货后, 2活动结束后
        sendDay: "", //发放天数，当sendType为1或2时有效
        venderIds: [],
        sellerSkuList: []
      },
      multiShopGoods: [],
      isKeyActivity: 0,
      placementPosition: [],
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },

      // 活动开始时间 =  锁权开始时间 ＜ 锁权结束时间 ≤ 兑奖开始时间＜兑奖结束时间 = 活动结束时间
      // lockPickerOptions: {
      //   disabledDate: (time) => {
      //     // if (this.ruleForm.lockStartTime) {
      //     //   if (this.ruleForm.prizeStartTime) {
      //     //     return (
      //     //       time.getTime() < Date.now() - 8.64e7 ||
      //     //       time.getTime() <
      //     //         new Date(this.ruleForm.lockStartTime).valueOf() ||
      //     //       time.getTime() >
      //     //         new Date(this.ruleForm.prizeStartTime).valueOf() ||
      //     //       (this.ruleForm.endTime &&
      //     //         time.getTime() >
      //     //           new Date(this.ruleForm.endTime).valueOf() -
      //     //             72 * 60 * 60 * 1000)
      //     //     );
      //     //   } else if (this.ruleForm.prizeEndTime) {
      //     //     return (
      //     //       time.getTime() < Date.now() - 8.64e7 ||
      //     //       time.getTime() <
      //     //         new Date(this.ruleForm.lockStartTime).valueOf() ||
      //     //       time.getTime() >
      //     //         new Date(this.ruleForm.prizeEndTime).valueOf() ||
      //     //       (this.ruleForm.endTime &&
      //     //         time.getTime() >
      //     //           new Date(this.ruleForm.endTime).valueOf() -
      //     //             72 * 60 * 60 * 1000)
      //     //     );
      //     //   } else {
      //     //     return (
      //     //       time.getTime() < Date.now() - 8.64e7 ||
      //     //       time.getTime() <
      //     //         new Date(this.ruleForm.lockStartTime).valueOf() ||
      //     //       (this.ruleForm.endTime &&
      //     //         time.getTime() >
      //     //           new Date(this.ruleForm.endTime).valueOf() -
      //     //             72 * 60 * 60 * 1000)
      //     //     );
      //     //   }
      //     // } else if (this.ruleForm.prizeStartTime) {
      //     //   return (
      //     //     time.getTime() < Date.now() - 8.64e7 ||
      //     //     time.getTime() >
      //     //       new Date(this.ruleForm.prizeStartTime).valueOf() ||
      //     //     (this.ruleForm.endTime &&
      //     //       time.getTime() >
      //     //         new Date(this.ruleForm.endTime).valueOf() -
      //     //           72 * 60 * 60 * 1000)
      //     //   );
      //     // } else {
      //     //   return (
      //     //     time.getTime() < Date.now() - 8.64e7 ||
      //     //     (this.ruleForm.endTime &&
      //     //       time.getTime() >
      //     //         new Date(this.ruleForm.endTime).valueOf() -
      //     //           72 * 60 * 60 * 1000)
      //     //   );
      //     // }
      //   },
      // },
      lockPickerOptions: {
        disabledDate: (time) => {
          //锁权结束时间必须小于或者等于活动结束时间并且必须大于或者等于锁权开始时间
          if (this.ruleForm.endTime) {
            // 检查是否小于锁权开始时间或大于活动结束时间
            const lockStartTime = this.ruleForm.lockStartTime ? new Date(this.ruleForm.lockStartTime).valueOf() : 0;
            const activityEndTime = new Date(this.ruleForm.endTime).valueOf();
            
            return time.getTime() < lockStartTime || time.getTime() > activityEndTime;
          } else {
            return false;
          }
        },
      },
      // prizeStartPickerOptions: {
      //   disabledDate: (time) => {
      //     if (this.ruleForm.lockEndTime) {
      //       if (this.ruleForm.prizeEndTime) {
      //         return (
      //           time.getTime() < Date.now() - 8.64e7 ||
      //           time.getTime() <
      //             new Date(this.ruleForm.lockEndTime).valueOf() - 8.64e7 ||
      //           time.getTime() > new Date(this.ruleForm.prizeEndTime).valueOf()
      //         );
      //       } else {
      //         return (
      //           time.getTime() < Date.now() - 8.64e7 ||
      //           time.getTime() < new Date(this.ruleForm.lockEndTime).valueOf()
      //         );
      //       }
      //     } else if (this.ruleForm.lockStartTime) {
      //       if (this.ruleForm.prizeEndTime) {
      //         return (
      //           time.getTime() < Date.now() - 8.64e7 ||
      //           time.getTime() <
      //             new Date(this.ruleForm.lockStartTime).valueOf() ||
      //           time.getTime() > new Date(this.ruleForm.prizeEndTime).valueOf()
      //         );
      //       } else {
      //         return (
      //           time.getTime() < Date.now() - 8.64e7 ||
      //           time.getTime() < new Date(this.ruleForm.lockStartTime).valueOf()
      //         );
      //       }
      //     } else if (this.ruleForm.prizeEndTime) {
      //       return (
      //         time.getTime() < Date.now() - 8.64e7 ||
      //         time.getTime() >
      //           new Date(this.ruleForm.prizeEndTime).valueOf() - 8.64e7
      //       );
      //     } else {
      //       return time.getTime() < Date.now() - 8.64e7;
      //     }
      //   },
      // },
      prizeStartPickerOptions: {
        disabledDate: (time) => {
          // 兑奖开始时间必须在锁权时间范围内：锁权开始时间 ≤ 兑奖开始时间 ≤ 锁权结束时间
          if (this.ruleForm.lockStartTime && this.ruleForm.lockEndTime) {
            const lockStartTime = new Date(this.ruleForm.lockStartTime).valueOf();
            const lockEndTime = new Date(this.ruleForm.prizeEndTime).valueOf();
            
            return time.getTime() < lockStartTime || time.getTime() > lockEndTime;
          } else {
            // 如果锁权时间未设置，则不禁用任何日期
            return false;
          }
        },
      },
      // 锁权开始时间≤下单开始时间＜下单结束时间≤兑奖结束时间
      orderStartPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.lockStartTime) {
            if (this.ruleForm.orderEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() - 8.64e7 ||
                time.getTime() > new Date(this.ruleForm.orderEndTime).valueOf()
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() - 8.64e7
              );
            }
          } else if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.orderEndTime).valueOf() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      orderEndPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            if (this.ruleForm.prizeEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.orderStartTime).valueOf() ||
                time.getTime() > new Date(this.ruleForm.prizeEndTime).valueOf()
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.orderStartTime).valueOf()
              );
            }
          } else if (this.ruleForm.prizeEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.prizeEndTime).valueOf() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },

      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: 0, // 将外部传入的步骤赋值到本地，避免直接更改props
      mainImagelist: [], //图片拖拽排序
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      selectGoodsStateFilter: false,
      getPrizeType: 1,
      ruleForm: {
        radio: 0,
        exposureSwitch: false,
        activityName: "",
        startTime: null,
        endTime: null,
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        lockStartTime: null,
        lockEndTime: null,
        prizeStartTime: null,
        prizeEndTime: null,

        orderStartTime: null,
        orderEndTime: null,
        orderPaymentType: 1,
        filterType: 0,
        filterSkuType: 0, // 指定商品规则
        itemStartCount: null,
        orderStartPayment: null,
        orderStateType: 0,
        point: null,

        // activityTheme: "锁权有礼",
        // activityRemark: "锁权后下单赢好礼",
        // textColor: defaultTextColor,

        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        openCardFollow: 1,

        // tapd-增加阶梯奖品
        prizeSettingType: 0,
        orderCountType: 1,
        receiveType: 0,
        lockType: 0,
        assetsId: "", //专享价/令牌id
        lockOrderStateType: 0, // 订单状态 0：已完成 1：已付款（下单付款后即可统计（预售商品需要支付尾款才统计））
        isValidBlackList: 0,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        goShopUrl: "",
        mergeOrder: false,
      },
      sharePic: "", // 初始图
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          orderPaymentLimit: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      jdCrm: {
        startTime: "",
        endTime: "",
        isCrm: false,
      },
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
      isFirstTime: true,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
    };
  },
  created() {
    console.log("当前玩法id", this.activityData.id);
    if (this.venderType) {
      this.ruleForm.orderPaymentType = 1;
    }
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
 async mounted() {
    this.initData()
    this.getLevel();
    this.publicOpen();
    // this.hdTaskTemplateGroup();
    this.getDetail();

    // 新增活动-初始化活动时间
    if (!this.valueRow && this.isFirstTime) {
      this.isFirstTime = false;
      this.setTime();
      this.activityTimeChange();
    }
  },

  methods: {
    changeLayout(val) {
      const obj = this.newGiftList.find(item => item.layout == val)
      if(obj) {
        this.templateId = obj.id
        this.templateObj = obj;
      }
    },
    defaultCustomSet(obj) {
      const rgb3 = this.normalizeColor(obj.rgb3)
      const rgb = this.normalizeColor(obj.rgb)
      const rgb2 = this.normalizeColor(obj.rgb2)
      if(!("btnColor" in this.customerPaperwork)) {
        this.$set(this.customerPaperwork, 'btnColor', rgb3);
      } 
      if(!("processColor" in this.customerPaperwork)) {
        this.$set(this.customerPaperwork, 'processColor', rgb);
      } 
      this.currrentRgb2 = rgb3
      this.currrentRgb3 = rgb
      this.currrentRgb = rgb2
    },
    normalizeColor(color) {
      if (!color) return color;
      if (typeof color !== 'string') return color;
      const trimmed = color.trim();
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(trimmed)) {
        return trimmed.toLowerCase();
      }
      const rgbMatch = trimmed.match(/^rgba?\(([^)]+)\)$/i);
      if (rgbMatch) {
        const parts = rgbMatch[1].split(',').map((s) => s.trim());
        const toHex = (n) => {
          const num = Math.max(0, Math.min(255, Math.round(parseFloat(n))));
          return num.toString(16).padStart(2, '0');
        };
        return `#${toHex(parts[0])}${toHex(parts[1])}${toHex(parts[2])}`;
      }
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.fillStyle = '#000000';
      ctx.fillStyle = trimmed;
      const hex = ctx.fillStyle;
      if (/^#[0-9a-f]{6}$/i.test(hex)) {
        return hex.toLowerCase();
      }
      return trimmed;
    },
    currentSet(obj) {
      const rgb3 = this.normalizeColor(obj.rgb3)
      const rgb = this.normalizeColor(obj.rgb)
      const rgb2 = this.normalizeColor(obj.rgb2)
      this.customerPaperwork.btnColor = rgb3
      this.customerPaperwork.processColor = rgb
      this.currrentRgb2 = rgb3
      this.currrentRgb3 = rgb
      this.currrentRgb = rgb2
    },
    selectTemplate(index,id){
      this.templateId = id
      this.templateJson.templateUItype = index;
      const obj = this.newGiftList.find(item => item.id == this.templateId)
      this.templateObj = obj;
      if(this.customerPaperwork.layout==2&&obj){
        this.currentSet(obj)
      }
    },
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    initData() {
      this.ruleDto.venderIds = [this.venderId];
      this.ruleDto.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, [this.venderId]);
    },
    removeToken(index) {
      this.tokenData.splice(index, 1);
      this.ruleForm.assetsId = "";
    },
    confirmToken(e,assetsId) {
      this.tokenData = [];
      this.focus = [];
      const { detailList } = e;
      detailList.forEach((item, index) => {
        const { promoSkuList, giveSkuList, promoStartTime, promoEndTime } =
          item;
        this.focus.push({
          timesOne: "",
          timesTwo: "",
          promotiProducts: [], //促销商品列表
          promotiProductsOne: [], //赠品SKU
        });
        this.focus[index].promotiProducts = promoSkuList;
        this.focus[index].promotiProductsOne = giveSkuList;
        this.focus[index].timesOne = promoStartTime;
        this.focus[index].timesTwo = promoEndTime;
      });
      this.tokenData.push(e);
      this.ruleForm.assetsId = e.id||assetsId;
      this.isShowselectToken = false
    },
    handlePage(page) {
      this.pageInfo.current = page.pageNum;
      this.pageInfo.size = page.pageSize;
    },
    confirmExclusive(val) {
      this.exclusivePriceData = val;
      this.ruleForm.assetsId = val.id;
      this.isShowExclusivePrice = false
    },
    // 选择专享价活动
    selectExclusivePrice() {
      this.isShowExclusivePrice = true;
    },
    // 阶梯设置,向下递增
    cumulativePayAmountChange(row, index) {
      for (let i = 0; i < this.prizeSettingList.length; i++) {
        if (i == index) {
          break;
        }
        if (this.ruleForm.prizeSettingType == 1) {
          if (!this.prizeSettingList[i].orderPaymentLimit) continue;
          if (
            !(
              this.prizeSettingList[i].orderPaymentLimit - 0 <
              row.orderPaymentLimit - 0
            )
          ) {
            row.orderPaymentLimit = "";
            this.$message.warning("当前阶梯累计消费金额必须大于上一阶梯");
            break;
          }
        }
      }
      for (let i = this.prizeSettingList.length - 1; i > 0; i--) {
        if (i == index) {
          break;
        }
        if (this.ruleForm.prizeSettingType == 1) {
          if (!this.prizeSettingList[i].orderPaymentLimit) continue;
          if (
            !(
              this.prizeSettingList[i].orderPaymentLimit - 0 >
              row.orderPaymentLimit - 0
            )
          ) {
            row.orderPaymentLimit = "";
            this.$message.warning("当前阶梯累计消费金额必须小于下一阶梯");
            break;
          }
        }
      }
    },
    itemDel(index) {
      if (this.prizeSettingList.length == 1) {
        this.$message.warning("必须有一个奖项");
        return;
      }
      this.prizeSettingList.splice(index, 1);
    },
    changePrizeSettingType() {
      this.prizeSettingList = [
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          orderPaymentLimit: null,
        },
      ];
    },
    addPrizeRule() {
      if (this.prizeSettingList.length === 5) {
        this.$message.warning("最多可添加5个阶梯！");
        return;
      }
      this.prizeSettingList.push({
        index: 0,
        prizeType: null,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        orderPaymentLimit: null,
      });
    },
    centerVisStep(item, index) {
      this.itemArr = this.prizeSettingList;
      this.index = index;
      this.JingdouCount.prizeCount = item.totalAmount;
      this.echoDate = item;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    filterTypeChange(val) {
      if (val == 0) {
        this.selectGoodsArr = [];
      } else if (val == 1) {
        this.selectGoodsArr = this.includeArr;
      } else if (val == 2) {
        this.selectGoodsArr = this.excludeArr;
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListForFilter = [];
        this.mainImagelist = [];
        this.selectGoodsFilterArr = [];
      }
    },
    selectGoodsCloseFilter(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
        this.mainImagelist = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      const order = this.mainImagelist.map((item) => item.skuId);
      this.itemListForFilter.sort((a, b) => {
        return order.indexOf(a.skuId) - order.indexOf(b.skuId);
      });
      this.selectGoodsFilterArr = this.itemListForFilter;
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (Number(row.totalAmount) < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 奖品logo校验
    async beforeUpload(file) {
      const status = await this.imgchecked(file, 646, 646);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 奖品logo上传成功
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.logo = res.data;
      }
    },
    //上传图片前校验   分享设置
    async beforeUpload1(file) {
      const status = await this.imgchecked(file);
      console.log(status);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.ruleForm.sharePic = res.data;
      }
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    filterGiftList(val) {
      this.giftList = this.allGiftList.filter((item) => item.layout == val);
      this.templateId = this.giftList[0].id;
      this.currentSet(this.giftList[0])
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      const list = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.allGiftList = list
      // 过滤对应样式类型
      this.giftList = this.allGiftList.filter((item) => item.layout == this.customerPaperwork.layout);
      if (!(this.valueRow && this.valueRow.id)) {
        this.templateId = this.giftList[0].id;
      }
      if(this.templateId) {
        let arr = this.newGiftList.filter(
          (item) => item.id == this.templateId
        );
        if(arr.length>0) {
          this.templateObj = arr[0];
        }
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `${url}${this.giftList[index].imageUrl}`,
        });
      }
    },

    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //验证发放天数
    validSe(e) {
      let value = e;
      value = value.replace(/[^0-9]/g, "");
      if (Number(value) > 365) {
        value = "365";
        this.$message.warning("发放天数不能超过365天");
      }
      if (value.length > 3) {
        value = value.slice(0, 3);
      }
      return value;
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //生成规则
    generateRule() {
      let text1 = "参与方式：在锁权时间范围内，进入活动手动消耗积分锁权参与；",
        text2 = "领奖方式：符合领奖条件的用户，需在兑奖时间范围内，进入活动手动领取奖品；",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "",
        text10 = "",
        text11 =
          "若用户存在刷奖等恶意行为，一经发现将取消获奖资格（如奖品已经发放，有权追回奖品；",
        text14 = "因客户原因导致的恶意退款，取消赠品获取资格；",
        text15 =
          "如果是实物奖项，需填写收货地址后进行发货，且仅有一次填写地址机会，活动结束后不允许填写地址，请在活动时间内填写地址，否则将视为放弃机会；",
        text16 = "",
        text17 =
          "1.锁权成功后，在下单期间达成指定条件，需在活动结束前进入活动页面领取奖品;如果是实物奖品，则需按要求预留收货地址，必须于活动结束时间前完成填写，逾期视为放弃领奖资格。" +
          "\n" +
          "2.如成功参与活动的用户对商品订单进行退款处理，导致实际支付金额不足活动门槛金额的，视为用户不符合兑换好礼资格，商家有权取消该用户获取奖品的资格。同一用户多个订单满足活动要求，也仅可获得1份奖品。" +
          "\n" +
          "3.由于活动奖品数量有限，系统将按照订单满足活动要求、且已提交收货信息的用户进行发奖。如果最后一份奖品排序时间出现同一时间点内有多个用户满足发奖要求，则会采取系统随机的方式进行抽取。" +
          "\n" +
          "4.奖品发放形式：" +
          "\n" +
          "【实物奖】：" +
          "\n" +
          "（1）用户中奖后，会通过弹窗的形式收集中奖用户的姓名、联系电话、详细地址，实物奖品采取寄送方式发放；" +
          "\n" +
          "（2）如出现下列情况，实物奖品将不予发放：① 因用户原因无法取得联系；② 用户未填写真实有效的信息或填写收货信息不详；③ 存在多个用户填写相同中奖人信息，则系统判自动判定为恶意刷奖行为；④超过有效期未填写地址视为放弃";
          const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember)
          let secondText= "\n二、【锁权时间与方式】", thirdText="\n三、【活动参与方式】\n",fourthText = "\n四、【如何获奖】\n",fifthText = "\n五、【注意事项】";
          fourthText+=text17
      // 锁权时间
      if (this.ruleForm.lockStartTime && this.ruleForm.lockEndTime) {
        text6 =
          "锁权时间：" +
          this.ruleForm.lockStartTime +
          "~" +
          this.ruleForm.lockEndTime;
      }
      // 兑奖时间
      if (this.ruleForm.prizeStartTime && this.ruleForm.prizeEndTime) {
        text7 =
          "兑奖时间：" +
          this.ruleForm.prizeStartTime +
          "~" +
          this.ruleForm.prizeEndTime;
      }
      // 活动奖品
      if (this.prizeSettingList && this.prizeSettingList.length) {
        if (this.prizeSettingList[0].title) {
          text8 = `活动奖品：${this.prizeSettingList[0].title}`;
        }
      }
      // 兑换条件
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        text9 = `兑奖条件：在${this.ruleForm.orderStartTime}~${this.ruleForm.orderEndTime}期间下单付款`;
        if (this.ruleForm.filterType == 0) {
          text9 += `店铺任意商品，`;
        } else if (this.ruleForm.filterType == 1) {
          text9 += `指定商品（指定商品见活动页），`;
        } else if (this.ruleForm.filterType == 2) {
          text9 += `除指定商品外的任意商品（排除商品见活动页），`;
        }
        if (this.ruleForm.itemStartCount) {
          text9 += `商品件数：大于等于${this.ruleForm.itemStartCount}件，`;
        }
        if (this.ruleForm.orderStartPayment) {
          text9 += `且订单金额：大于等于${this.ruleForm.orderStartPayment}元；`;
        }
        if (this.ruleForm.filterType == 1) {
          text9 += `（统计时间段内购买指定商品的整单商品件数及金额）`;
        } else if (this.ruleForm.filterType == 2) {
          text9 += `（统计时间段内购买排除商品之外的商品件数及金额，含排除商品的订单整单排除）`;
        }
        text9 += `且订单状态为${
          this.ruleForm.orderStateType == 0 ? "已完成；" : "已付款；"
        }`;
      }

      if (this.ruleForm.point) {
        text10 += `活动领奖限制：用户需要锁权期间支付${this.ruleForm.point}积分锁权，在下单期间达成指定条件，在活动结束前进入活动页面领取奖品；`;
      }

      const info = sessionStorage.getItem("loginUserInfo");
      const loginUserInfo = JSON.parse(info);
      if (
        this.ruleForm.point &&
        this.ruleForm.prizeStartTime &&
        this.ruleForm.prizeEndTime &&
        loginUserInfo.shopTitle
      ) {
        text16 = 
          `1.会员在锁定权益阶段于指定页面消耗${this.ruleForm.point}积分完成锁权。` +
          "\n" +
          "2.会员锁定权益后进入下单购买阶段，该阶段会员需在指定期限内于京东" +
          `【${loginUserInfo.shopTitle}】` +
          "购买指定产品累计金额达到上述规则（金额中不包含售中退款/售后退款），且在活动指定期限内于" +
          this.ruleForm.prizeStartTime +
          "~" +
          this.ruleForm.prizeEndTime +
          "内进入活动领取奖品，奖品数量有限，先到先得，赠完即止。";
      }
      thirdText += text16
      let Arr1 = [
        firstText,
        [secondText,text1,text6,text2,text7,text8,text9,text10,text11,text14,text15],
        [thirdText],
        [fourthText],
        [fifthText,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });

      this.ruleForm.ruleDescription = newText;
    },
    //选择奖品弹窗
    centerVis(row) {
      this.itemArr = this.prizeSettingList;
      this.index = row.index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = Number(data.discount);

      this.prizeSettingList[this.index].assetsId = Number(data.couponId || data.skuId);
      this.prizeSettingList[this.index].logo = data.logo || this.defaultLogo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      this.prizeSettingList[this.index].title = data.name;

      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.prizeSettingList[this.index].skuId = data.skuId;
          delete this.prizeSettingList[this.index].isGoodManage;
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
        this.prizeSettingList[this.index].addressFillEndTime =
          data.addressFillEndTime;
        this.prizeSettingList[this.index].isFollowActivityEndTime =
          data.isFollowActivityEndTime;
        this.prizeSettingList[this.index].predictSendTime =
          data.predictSendTime;
        this.prizeSettingList[this.index].shouldCollectExtraData =
          data.shouldCollectExtraData;
        this.prizeSettingList[this.index].extraQuestion =
          data.extraQuestion;
        this.prizeSettingList[this.index].addressFillLimit =
          data.addressFillLimit;
        this.prizeSettingList[this.index].commitAddressLimit =
          data.commitAddressLimit;
      }
      // 实物随单发
      if(prizeType == 14||prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingList[this.index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
      }

      // 锁权时间
      if (!this.ruleForm.lockEndTime) {
        this.$message.warning("请选择锁权时间");
        return;
      }

      // 兑奖时间
      if (!this.ruleForm.prizeStartTime) {
        this.$message.warning("请选择兑奖时间");
        return;
      }

      // 下单时间
      if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
        this.$message.warning("请选择下单时间");
        return;
      }
      // 锁权时间顺序
      if (
        new Date(this.ruleForm.lockEndTime).valueOf() <=
        new Date(this.ruleForm.lockStartTime).valueOf()
      ) {
        this.$message.warning("锁权结束时间不能小于锁权开始时间");
        return;
      }

      if (
        new Date(this.ruleForm.prizeStartTime).valueOf() >
        new Date(this.ruleForm.prizeEndTime).valueOf()
      ) {
        this.$message.warning("兑奖结束时间不能小于兑奖开始时间");
        return;
      }

      // 锁权所需积分
      if (this.ruleForm.lockType == 0 && !this.ruleForm.point) {
        this.$message.warning("请输入锁权所需积分");
        return;
      }

      if (this.ruleForm.lockType == 1 && !this.ruleForm.assetsId) {
        if (this.venderType) {
          this.$message.warning("请选择令牌");
        } else {
          this.$message.warning("请选择特惠商品");
        }
        return;
      }


      if (
        new Date(this.ruleForm.orderStartTime).valueOf() >=
        new Date(this.ruleForm.orderEndTime).valueOf()
      ) {
        this.$message.warning("下单结束时间不能小于下单开始时间");
        return;
      }

      // if (
      //   new Date(this.ruleForm.orderEndTime).valueOf() >
      //   new Date(this.ruleForm.prizeEndTime).valueOf()
      // ) {
      //   this.$message.warning("兑奖结束时间不能小于下单结束时间");
      //   return;
      // }

      // 商品要求
      // if (this.ruleForm.filterType == 1 && !this.selectGoodsArr.length) {
      //   this.$message.warning("请选择指定商品");
      //   return;
      // }
      // if (this.ruleForm.filterType == 2 && !this.selectGoodsArr.length) {
      //   this.$message.warning("请选择排除商品");
      //   return;
      // }
      // 商品件数
      // if (!this.ruleForm.itemStartCount) {
      //   this.$message.warning("请输入商品件数");
      //   return;
      // }
      if(this.ruleForm.filterType!=0) {
          const obj = this.ruleDto.sellerSkuList.find((item) => item.skuIds.length==0)
          if(obj) {
            const types = {
              1: "指定",
              2: "排除",
            }
            const shop = this.multiShopGoods.find((item) => item.venderId == obj.venderId)
            this.$message.warning(`请选择${shop.shopTitle}的${types[this.ruleForm.filterType]}商品`);
            return;
          }
        }
      // 订单金额
      if (!this.ruleForm.orderStartPayment) {
        this.$message.warning("请输入订单金额");
        return;
      }
      // 下单跳转链接校验
      if (this.ruleForm.goShopSetting == 1 && !this.ruleForm.goShopAppId) {
          this.$message.warning("请输入小程序appId");
          return;
        }
        if (this.ruleForm.goShopSetting == 2) {
          if (!this.ruleForm.goShopUrl) {
            this.$message.warning("请输入指定链接");
            return;
          } else if (
            !this.ruleForm.goShopUrl.startsWith("https://") ||
            !this.ruleForm.goShopUrl.includes("jd.com")
          ) {
            this.$message.warning(
              "输入的内容非链接或为接口无法支持的链接，请重新设置"
            );
            return;
          }
        }
      // 请将奖品填写完整！
      let isFlay = false;
      let isNull = false;

      this.prizeSettingList.forEach((item) => {
        if (!item.prizeType || !item.totalAmount) {
          isFlay = true;
        }
        if (this.ruleForm.prizeSettingType == 1) {
          if (!item.orderPaymentLimit) {
            isNull = true;
            return;
          }
        }
      });

      if (isFlay) {
        this.$message.warning("请将奖品填写完整！");
        return;
      }
      if (isNull) {
        this.$message.warning("请设置阶梯订单金额！");
        return;
      }

      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListForFilter.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }

      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      const {
        activityName,
        startTime,
        endTime,
        condFollow,
        radio,
        partner,
        ruleDescription,
        lockStartTime,
        lockEndTime,
        prizeStartTime,
        prizeEndTime,
        orderStartTime,
        orderEndTime,
        orderPaymentType,
        filterType,
        filterSkuType, // 指定商品规则
        itemStartCount,
        orderStartPayment,
        orderStateType,
        point,
        shareTitle,
        shareIntroduce,
        sharePic,
        firstOpenCardTimeType,
        openCardBeforeDay,
        openCardFollow,
        prizeSettingType,
        orderCountType,
        receiveType,
        lockOrderStateType,
        goShopSetting,
        goShopAppId,
        goShopUrl,
        studentSatus,
        mergeOrder,
      } = this.ruleForm;

      const obj = {
        activityName,
        startTime,
        endTime,
        condFollow: Number(condFollow),
        ruleDTO: {},
        priceType: radio, //  0：显示京东价 1：显示促销
        ruleDescription,
        templateId: this.templateId,
        studentSatus
      };
      // 活动对象
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
        // 入会时间
        obj.ruleDTO.firstOpenCardTimeType = firstOpenCardTimeType;
        obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime;
        obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime;
        obj.ruleDTO.openCardBeforeDay = openCardBeforeDay;
      }
      obj.ruleDTO.openCardFollow = openCardFollow;
      // 自定义背景
      obj.ruleDTO.cusTemplateJSON = this.ruleDto.cusTemplateJSON;
      // 强提醒
      obj.ruleDTO.isForceRemind = this.ruleDto.isForceRemind;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity;
      // 活动投放位置
      obj.placementPosition = this.placementPosition.join(",");
      // plus会员
      obj.ruleDTO.plusObject = this.ruleDto.plusObject;

      // 锁权时间
      obj.ruleDTO.lockStartTime = lockStartTime;
      obj.ruleDTO.lockEndTime = lockEndTime;
      // 兑奖时间
      obj.ruleDTO.prizeStartTime = prizeStartTime;
      obj.ruleDTO.prizeEndTime = prizeEndTime;

      // 下单时间
      obj.ruleDTO.orderStartTime = orderStartTime;
      obj.ruleDTO.orderEndTime = orderEndTime;
      // 金额统计类型
      obj.ruleDTO.orderPaymentType = orderPaymentType;
      // 订单拆单后是否合并
      obj.ruleDTO.mergeOrder = mergeOrder;

      //商品要求
      obj.ruleDTO.filterType = filterType;
      obj.ruleDTO.filterSkuType = filterSkuType; // 指定商品规则
      if(filterType!=0) {
        obj.ruleDTO.itemList = [];
        obj.ruleDTO.skuIdLis = []
      }
      obj.ruleDTO.sellerSkuList = this.ruleDto.sellerSkuList;
      obj.ruleDTO.venderIds = this.ruleDto.venderIds;
      // if (filterType == 1) {
      //   obj.ruleDTO.itemList = this.includeArr;
      //   obj.ruleDTO.skuIdList = this.includeArr.map((item) => item.skuId);
      // } else if (filterType == 2) {
      //   obj.ruleDTO.itemList = this.excludeArr;
      //   obj.ruleDTO.skuIdList = this.excludeArr.map((item) => item.skuId);
      // }
      //商品件数
      obj.ruleDTO.itemStartCount = itemStartCount;
      // 订单金额
      obj.ruleDTO.orderStartPayment = orderStartPayment;
      // 订单状态
      obj.ruleDTO.orderStateType = orderStateType;

      // 下单跳转链
        obj.ruleDTO.goShopSetting = goShopSetting;
        obj.ruleDTO.goShopAppId = goShopAppId;
        obj.ruleDTO.goShopUrl = goShopUrl;
      // 奖品设置
      const hasPrize = this.prizeSettingList.every((item) => item.prizeType);
      if (hasPrize) {
        obj.pointActivityPrizeDTOList = this.prizeSettingList.map(
          (item, index) => {
            if (prizeSettingType == 1) {
              return {
                ...item,
                taskIndex: index + 1,
              };
            } else {
              return item;
            }
          }
        );
      } else {
        obj.pointActivityPrizeDTOList = [];
      }

      // 阶梯
      if (prizeSettingType == 1) {
        obj.ruleDTO.prizeSettingType = prizeSettingType;
        obj.ruleDTO.orderCountType = orderCountType;
        obj.ruleDTO.receiveType = receiveType;
        let stepList = [];
        obj.pointActivityPrizeDTOList.forEach((item, index) => {
          stepList.push({
            taskIndex: index + 1,
            orderPaymentLimit: item.orderPaymentLimit,
          });
        });
        obj.ruleDTO.stepList = stepList;
      }

      // 锁权所需积分
      obj.ruleDTO.point = point;
      // 锁权规则
      obj.ruleDTO.lockType = this.ruleForm.lockType;
      obj.ruleDTO.assetsId =
        this.ruleForm.lockType == 1 ? this.ruleForm.assetsId : "";
      obj.ruleDTO.lockOrderStateType = lockOrderStateType;
      // 活动页设置
      // const activitySetting = {
      //   activityTheme,
      //   activityRemark,
      //   textColor,
      // };
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      // 曝光商品
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0; //是否添加曝光商品 0 否 1 是
      if (obj.isExposureItem) {
        obj.itemList = this.itemListForFilter;
      }
      obj.ruleDTO.multiShopSkuType = this.multiShopSkuType || 0
      obj.ruleDTO.skuBelongVenderId = this.multiShopSkuType==0 && this.itemListForFilter.length>0 ? this.itemListForFilter[0].belongVenderId : "",
      // 分享设置
      obj.ruleDTO.shareTitle = shareTitle;
      obj.ruleDTO.shareIntroduce = shareIntroduce;
      obj.ruleDTO.sharePic = sharePic;

      // 奖品发放形式
      obj.ruleDTO.sendType = this.ruleDto.sendType;
      obj.ruleDTO.sendDay = this.ruleDto.sendDay;

      // 黑名单
      obj.isValidBlackList = this.ruleForm.isValidBlackList;

      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: this.prizeSettingList.map((item) => {
              const prize = {
                ...item,
                prizeId: item.id,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              return prize;
            }),
            isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
            itemList: this.itemListForFilter,
            activityName: obj.activityName,
            condFollow: obj.condFollow,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          if (this.isDraft) {
            obj.status = 5;
          } else {
            // 保存正式活动不需要status
            if (obj.status) {
              delete obj.status;
            }
            if (!this.activityData.isCopy && !this.isDraftEdit) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
              }
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
          }
          pointLockSave(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getPointLockDetail(this.valueRow.id)
          .then((res) => {
            this.isCreated = true
            this.loading = false;
            try {
              const {
                activityName,
                startTime,
                endTime,
                allowLevel,
                condFollow,
                ruleDescription,
                ruleDto,
                pointActivityPrizeDTOList,
                isExposureItem,
                studentSatus,
              } = res.data;
              const {
                lockStartTime,
                lockEndTime,
                prizeStartTime,
                prizeEndTime,
                orderStartTime,
                orderEndTime,
                orderPaymentType,
                filterType,
                filterSkuType, // 指定商品规则
                itemList,
                itemStartCount,
                orderStartPayment,
                orderStateType,
                point,
                customerPaperwork,
                firstOpenCardTimeType,
                openCardStartTime,
                openCardEndTime,
                plusObject,
                shareTitle,
                shareIntroduce,
                sharePic,
                openCardBeforeDay,
                openCardFollow,
                prizeSettingType,
                orderCountType,
                receiveType,
                stepList,
                sendType,
                sendDay,
                lockType,
                assetsId,
                lockOrderStateType,
                sellerSkuList,
                venderIds,
                skuIdList,
                skuBelongVenderId,
                multiShopSkuType,
                goShopSetting,
                goShopAppId,
                goShopUrl,
                mergeOrder,
              } = ruleDto;
              // 活动名称
              this.ruleForm.activityName =
                activityName + (this.activityData.isCopy ? "复制" : "");
              // 记录活动结束时间
              this.actEndTime = endTime;
              // 活动对象
              if (allowLevel == "99") {
                this.peopleSelected = res.data.crowdIds.split(",");
                this.actMember = "3";
              } else if (allowLevel == "-1") {
                this.actMember = "1";
              } else {
                this.actMember = "2";
                if (allowLevel.indexOf("-1") != -1) {
                  this.ruleForm.partner = ["-1"];
                } else {
                  this.ruleForm.partner = allowLevel.split(",");
                }
              }
              // 模板id
              if (res.data.templateId) {
                this.templateId = res.data.templateId;
              }
              // 自定义背景图
              this.ruleDto.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON;
              // 强提醒
              this.ruleDto.isForceRemind = res.data.ruleDto.isForceRemind;
              // 是否重点活动
              this.isKeyActivity = res.data.isKeyActivity;
              // 活动投放位置
              this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"];
              // 关注
              this.ruleForm.condFollow = Boolean(condFollow);
              // 入会时间
              this.ruleDto.firstOpenCardTimeType = firstOpenCardTimeType;
              if (openCardStartTime && openCardEndTime) {
                this.ruleDto.firstOpenCardTimeType = 2;
              }
              this.ruleDto.openCardStartTime = openCardStartTime;
              this.ruleDto.openCardEndTime = openCardEndTime;
              this.ruleForm.openCardBeforeDay = openCardBeforeDay || "";
              this.ruleForm.openCardFollow = openCardFollow || 1;
              // plus会员
              this.ruleDto.plusObject = plusObject;
              // 奖品发放形式
              this.ruleDto.sendType = sendType || 0;
              this.ruleDto.sendDay = sendDay || "";
              this.ruleForm.studentSatus = studentSatus || "";

              // 锁权时间
              this.ruleForm.lockStartTime = lockStartTime;
              this.ruleForm.lockEndTime = lockEndTime;
              // 兑奖时间
              this.ruleForm.prizeStartTime = prizeStartTime;
              this.ruleForm.prizeEndTime = prizeEndTime;

              // 下单时间
              this.ruleForm.orderStartTime = orderStartTime;
              this.ruleForm.orderEndTime = orderEndTime;
              // 金额统计类型
              this.ruleForm.orderPaymentType = orderPaymentType;
              // 订单拆单后是否合并
              this.ruleForm.mergeOrder = mergeOrder||false;
              // 下单跳转链接
              this.ruleForm.goShopSetting = goShopSetting || 0;
              this.ruleForm.goShopAppId = goShopAppId;
              this.ruleForm.goShopUrl = goShopUrl;

              //商品要求
              this.ruleForm.filterType = filterType;
              // 指定商品规则
              this.ruleForm.filterSkuType = filterSkuType||0; // 指定商品规则
              this.ruleDto.sellerSkuList = sellerSkuList&&sellerSkuList.length>0 ? sellerSkuList : [{
                venderId: this.venderId,
                skuIds: skuIdList&&skuIdList.length>0 ? skuIdList : [],
                itemList: []
              }];
              this.ruleDto.venderIds = venderIds&&venderIds.length>0 ? venderIds : [this.venderId];
              if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(this.ruleDto.venderIds.length>0) {
                let index = this.ruleDto.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  this.ruleDto.venderIds.unshift(Number(this.venderId))
                  this.ruleDto.sellerSkuList.unshift({
                    venderId: Number(this.venderId),
                    skuIds: [],
                    itemList: [],
                  })
                }
              }
            }
              this.multiShopGoods = useValidateMultiShopGoods(this,this.ruleDto.venderIds);
              this.hasSelectGoods = itemList;
              this.filterTypeChange(filterType);
              //商品件数
              this.ruleForm.itemStartCount = itemStartCount;
              // 订单金额
              this.ruleForm.orderStartPayment = orderStartPayment;
              // 订单状态
              this.ruleForm.orderStateType = orderStateType;

              // 锁权所需积分
              this.ruleForm.point = point;

              // 曝光商品
              this.ruleForm.exposureSwitch = isExposureItem ? true : false;
              if (this.ruleForm.exposureSwitch) {
                this.itemListForFilter = res.data.itemList;
                this.mainImagelist = res.data.itemList;
                this.selectGoodsFilterArr = res.data.itemList;
              }

              // 活动页设置
              const activitySetting = JSON.parse(customerPaperwork);
              // this.ruleForm.activityTheme = activitySetting.activityTheme;
              // this.ruleForm.activityRemark = activitySetting.activityRemark;
              // this.ruleForm.textColor = activitySetting.textColor;
              activitySetting.layout = activitySetting.layout ? activitySetting.layout : 2;
              this.customerPaperwork = activitySetting;
              // 分享设置回显
              this.ruleForm.shareTitle = shareTitle;
              this.ruleForm.shareIntroduce = shareIntroduce;
              this.ruleForm.sharePic = sharePic;
              // 黑名单回显
              this.ruleForm.isValidBlackList = res.data.isValidBlackList;

              // 阶梯
              this.ruleForm.prizeSettingType = prizeSettingType;
              this.ruleForm.orderCountType = orderCountType;
              this.ruleForm.receiveType = receiveType;
              this.multiShopSkuType = multiShopSkuType || 0
              this.skuBelongVenderId = skuBelongVenderId || "";
              // 锁权规则回显
              this.ruleForm.lockType = lockType || 0;
              this.ruleForm.assetsId = assetsId;
              if (this.ruleForm.lockType == 1) {
                if (!this.venderType) {
                  // TODO: POP店铺拿assetsId查询专享价详情
                  this.ruleForm.lockOrderStateType = lockOrderStateType || 0;
                  getExclusivePricePlanDetail(this.ruleForm.assetsId).then(
                    (res) => {
                      if (res.code == 1) {
                        this.exclusivePriceData = res.data;
                      }
                    }
                  );
                } else {
                  // TODO： 自营店铺查令牌
                  promoTokenDetail({
                    id: this.ruleForm.assetsId,
                  }).then((res) => {
                    if (res.code == 1) {
                      this.confirmToken(res.data,assetsId)
                    }
                  });
                }
              }

              if (!this.activityData.isCopy) {
                // 活动时间
                this.ruleForm.startTime = startTime;
                this.ruleForm.endTime = endTime;
                // 奖品设置
                this.prizeSettingList = pointActivityPrizeDTOList.map(
                  (item, index) => {
                    let orderPaymentLimit = "";
                    if (prizeSettingType == 1) {
                      let obj = stepList.find(
                        (item2) => item2.taskIndex == item.taskIndex
                      );
                      orderPaymentLimit = obj ? obj.orderPaymentLimit : "";
                    }
                    const prizeItem = {
                      ...item,
                      index,
                      orderPaymentLimit,
                    };
                    // 提交地址限制回显：逗号分隔字符串转数字数组
                    if (item.prizeType == 3) {
                      if (item.commitAddressLimit) {
                        prizeItem.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                          ? item.commitAddressLimit.split(',').map(Number)
                          : item.commitAddressLimit;
                      } else {
                        prizeItem.commitAddressLimit = [0];
                      }
                    }
                    return prizeItem;
                  }
                );
                this.ruleForm.ruleDescription = ruleDescription;
              }
              this.getPolite();
              this.activityTimeChange();
            } catch (e) {
              console.lolg(e);
            }
          })
          .catch((res) => {});
      } else {
        this.getPolite();
      }
    },
    // 初始化时间
    setTime() {
      this.ruleForm.startTime = this.$getDate(30)[0];
      // 判断当前时间是否大于软件有效期
      const endTime = this.$getDate(30)[1];
      const endTimeValue = new Date(endTime).valueOf();
      const expiresIn = this.$store.getters.loginUserInfo.expiresIn;
      let expiresInValue = new Date(expiresIn).valueOf();
      if (endTimeValue > expiresInValue) {
        this.ruleForm.endTime = expiresIn;
      } else {
        this.ruleForm.endTime = endTime;
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      // 锁权开始时间
      this.ruleForm.lockStartTime = null;
      // 兑奖时间
      this.ruleForm.prizeEndTime = null;
    },
    // 清空锁权结束时间
    cleaerLockTime() {
      this.ruleForm.lockEndTime = null;
    },
    // 清空兑奖开始时间
    cleaerPrizeTime() {
      this.ruleForm.prizeStartTime = null;
    },
    // 清空下单时间
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    // 活动时间改变
    activityTimeChange() {
      // 锁权开始时间
      this.ruleForm.lockStartTime = this.ruleForm.startTime;
      // 兑奖时间
      this.ruleForm.prizeEndTime = this.ruleForm.endTime;
      return;
      // 校验有无时间
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let CRMtime = new Date(this.jdCrm.endTime).valueOf();
      let platformInvalidateDate =
        this.$store.getters.loginUserInfo.platformInvalidateDate;
      // 店铺接入有效期
      if (this.softType == 1) {
        // 京获客旗舰版
        platformInvalidateDate =
          this.$store.getters.loginUserInfo.invalidateDate;
      }
      const hdInvalidateDate =
        this.$store.getters.loginUserInfo.hdInvalidateDate;
      let platformInvalidateDateValue = new Date(
        platformInvalidateDate
      ).valueOf();
      // 互动数据授权
      let hdInvalidateDateValue = new Date(hdInvalidateDate).valueOf();
      var date3;
      const platformInvalidateDateStr = platformInvalidateDate
        ? platformInvalidateDate.split(" ")[0]
        : "";
      const hdInvalidateDateStr = hdInvalidateDate
        ? hdInvalidateDate.split(" ")[0]
        : "";
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end < nowTime) {
        this.$message.warning("活动结束时间不能小于当前时间！");
      }
      if (end < start) {
        this.$message.warning("活动开始时间不能大于结束时间！");
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.ruleForm.endTime = "";
        return;
      }
      if (end > platformInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过店铺接入有效期${platformInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
      if (end > hdInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过互动数据授权有效期${hdInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
    },
    //添加指定商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.selectGoodsArr.length == 0) {
        this.selectGoodsArr = [];
        this.selectGoodsArr = [];
      }
      if (this.ruleForm.filterType == 1) {
        this.selectGoodsArr = this.includeArr;
      } else if (this.ruleForm.filterType == 2) {
        this.selectGoodsArr = this.excludeArr;
      }
      this.$nextTick(() => {
        this.$refs.selectGo.handleRightCurrentChange(1);
      });
    },

    selectGoodsClose(data) {
      if (data) {
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        if (this.ruleForm.filterType == 1) {
          this.includeArr = selectGoodsArr;
        } else if (this.ruleForm.filterType == 2) {
          this.excludeArr = selectGoodsArr;
        }
        this.selectGoodsArr = selectGoodsArr;
      }
      this.selectGoodsState = false;
    },
    // 是否自营
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          var data1 = new Date(res.message);
          var data2 = new Date();
          this.jdCrm.endTime = res.message;
          if (data1.getTime() > data2.getTime()) {
            this.jdCrm.isCrm = true;
          } else {
            this.jdCrm.isCrm = false;
          }
        }
      });
    },
    toCreated(uitype, templateId = 0) {
      if (sessionStorage.getItem("venderType") == 0) {
        this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateJson.templateUItype = uitype;
      // 新增活动-初始化活动时间
      if (!this.valueRow && this.isFirstTime) {
        this.isFirstTime = false;
        this.setTime();
        this.activityTimeChange();
      }
    },
    toCreated1(uitype, templateId = 0) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = uitype;
      if (templateId) {
        this.templateId = templateId;
      }
    },
    toCRM() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.ruleForm.exposureSwitch = false;
      this.selectGoodsStateFilter = false;
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 重置颜色
    resetColor() {
      this.ruleForm.textColor = defaultTextColor;
    },
    // 判断是否同一天
    isSameDay(date1, date2) {
      // 将日期转换为Date对象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 设置时间为午夜12点（这样可以忽略时分秒）
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);

      // 比较年月日是否相同
      return d1.getTime() === d2.getTime();
    },
    // 获取时间
    getAllTime(date) {
      const time = new Date(date);
      let yy = time.getFullYear(); //当前年份
      let mm =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      let dd = time.getDate() < 10 ? "0" + time.getDate() : time.getDate(); //当前天数
      return `${yy}-${mm}-${dd} ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
    },
    // lockEndTimeChange() {
    //   // if (this.ruleForm.prizeStartTime && this.ruleForm.endTime) {
    //   //   // 使用兑奖开始时间的时分秒
    //   //   const actEndTime72 =
    //   //     new Date(this.ruleForm.endTime).valueOf() - 72 * 60 * 60 * 1000;
    //   //   if (actEndTime72 > new Date(this.ruleForm.prizeStartTime).valueOf()) {
    //   //     if (
    //   //       this.isSameDay(
    //   //         this.ruleForm.lockEndTime,
    //   //         this.ruleForm.prizeStartTime
    //   //       ) &&
    //   //       new Date(this.ruleForm.lockEndTime).valueOf() >
    //   //         new Date(this.ruleForm.prizeStartTime).valueOf()
    //   //     ) {
    //   //       this.ruleForm.lockEndTime = this.ruleForm.prizeStartTime;
    //   //     }
    //   //   } else {
    //   //     if (
    //   //       this.isSameDay(this.ruleForm.lockEndTime, actEndTime72) &&
    //   //       new Date(this.ruleForm.lockEndTime).valueOf() >
    //   //         new Date(this.ruleForm.actEndTime72).valueOf()
    //   //     ) {
    //   //       this.ruleForm.lockEndTime = this.getAllTime(actEndTime72);
    //   //     }
    //   //   }
    //   // } else if (this.ruleForm.prizeStartTime) {
    //   //   if (
    //   //     this.isSameDay(
    //   //       this.ruleForm.lockEndTime,
    //   //       this.ruleForm.prizeStartTime
    //   //     ) &&
    //   //     new Date(this.ruleForm.lockEndTime).valueOf() >
    //   //       new Date(this.ruleForm.prizeStartTime).valueOf()
    //   //   ) {
    //   //     this.ruleForm.lockEndTime = this.ruleForm.prizeStartTime;
    //   //   }
    //   // } else if (this.ruleForm.endTime) {
    //   //   const actEndTime72 =
    //   //     new Date(this.ruleForm.endTime).valueOf() - 72 * 60 * 60 * 1000;
    //   //   if (
    //   //     this.isSameDay(this.ruleForm.lockEndTime, actEndTime72) &&
    //   //     new Date(this.ruleForm.lockEndTime).valueOf() >
    //   //       new Date(this.ruleForm.actEndTime72).valueOf()
    //   //   ) {
    //   //     this.ruleForm.lockEndTime = this.getAllTime(actEndTime72);
    //   //   }
    //   // }
    // },
    lockEndTimeChange() {
      if (this.ruleForm.endTime) {
        if (
          this.isSameDay(this.ruleForm.endTime, this.ruleForm.lockEndTime) &&
          new Date(this.ruleForm.lockEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.ruleForm.lockEndTime = this.ruleForm.endTime;
        }
      }
    },
    prizeStartTimeChange() {
      if (this.ruleForm.lockEndTime) {
        if (
          this.isSameDay(
            this.ruleForm.lockEndTime,
            this.ruleForm.prizeStartTime
          ) &&
          new Date(this.ruleForm.prizeStartTime).valueOf() <
            new Date(this.ruleForm.lockEndTime).valueOf()
        ) {
          this.ruleForm.prizeStartTime = this.ruleForm.lockEndTime;
        }
      }
    },
    orderStartTimeChange() {
      if (this.ruleForm.lockStartTime) {
        if (
          this.isSameDay(
            this.ruleForm.lockStartTime,
            this.ruleForm.orderStartTime
          ) &&
          new Date(this.ruleForm.orderStartTime).valueOf() <
            new Date(this.ruleForm.lockStartTime).valueOf()
        ) {
          this.ruleForm.orderStartTime = this.ruleForm.lockStartTime;
        }
      }
    },
    orderEndTimeChange() {
      if (this.ruleForm.endTime) {
        if (
          this.isSameDay(this.ruleForm.endTime, this.ruleForm.orderEndTime) &&
          new Date(this.ruleForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.ruleForm.orderEndTime = this.ruleForm.endTime;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox) {
  margin: 16px 0;
}
.rule_box {
  width: 860px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
  .support {
    display: flex;
    align-items: center;
    &-text {
      margin: 0px 8px;
    }
    &-icon {
      color: #ccc;
      cursor: pointer;
    }
  }
}

.input-w425 {
  width: 425px;
}

.label {
  &-right {
    margin-right: 8px;
  }
  &-left {
    margin-left: 8px;
  }
}

.el-icon-question {
  color: #ccc;
  cursor: pointer;
}

.flex-center {
  display: flex;
  align-items: center;
}

.el-textarea {
  /deep/ .el-input__count {
    padding: 0px 5px;
    line-height: normal;
  }
}
.mlr8 {
  margin: 0 8px;
}

.ml8 {
  margin-left: 8px;
}

.ml8 {
  margin-right: 8px;
}
</style>
<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
</style>
